require('expose-loader?$!jquery')
require('expose-loader?jQuery!jquery')
require('javascripts/jquery.serialize-object')
require('javascripts/jquery-ujs.custom')
require('javascripts/jquery-ui.min')
require('javascripts/jquery.autosize')
require('javascripts/jquery.color')
require('javascripts/jquery.mousewheel')
require('jquery-toc')
require('expose-loader?moment!moment')
require('moment/locale/zh-cn')
require('moment-timezone/builds/moment-timezone-with-data-2012-2022')
require('moment-readable/lib/moment-readable')
require('expose-loader?cocoon!cocoon-rails/src/cocoon')

require('expose-loader?Pusher!pusher-js/dist/web/pusher')
require('javascripts/offline')
require('expose-loader?echarts!javascripts/echarts.min')
require('expose-loader?PhotoSwipe!javascripts/photoswipe.4.1.2.hack')
require('expose-loader?PhotoSwipeUI_Default!photoswipe/dist/photoswipe-ui-default')

require('expose-loader?SimpleModule!simple-module')
require('expose-loader?simple.util!simple-util')

// see doc/oss_direct_upload.md
require('expose-loader?simple.uploader!simple-uploader')
require('javascripts/uploader-hack')

require('expose-loader?simple.hotkeys!simple-hotkeys')
require('expose-loader?simple.tpl!simple-template')
require('expose-loader?simple.url!simple-url')
require('expose-loader?simple.pjax!simple-pjax')
require('expose-loader?simple.stack!simple-stack')
require('expose-loader?simple.tree!simple-tree')
require('expose-loader?simple.checkbox!simple-checkbox')
require('expose-loader?simple.momentpicker!simple-momentpicker')
require('expose-loader?simple.tooltip!simple-tooltip')
require('expose-loader?simple.autosave!simple-autosave')
require('expose-loader?simple.loading!simple-loading')
require('expose-loader?simple.dialog!simple-dialog')
require('expose-loader?simple.popover!simple-popover')
require('expose-loader?simple.select!simple-select')
require('expose-loader?simple.scrollTo!simple-scrollTo')
require('expose-loader?simple.dragdrop!simple-dragdrop')
require('expose-loader?simple.calendar!simple-calendar')
require('expose-loader?simple.filedrop!simple-filedrop')
require('expose-loader?simple.subtasks!simple-subtasks')

require('file-saver')
require('expose-loader?gwm!gwm')
